import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as stockActions from "../../../../../actions/stockActions";
import * as modelHelper from "../../../../../helpers/modelHelper";

import Button from "../../../../global/generic/Button";
import Table, {TABLE_VARIANT_SECONDARY} from "../../../../global/generic/Table";
import Modal from "../../../../global/generic/Modal";
import CancelButton from "../../../../global/generic/CancelButton";

class ColorantPackagesConfirmOrderStockModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseColorantPackagesConfirmOrderStockModalAction();
    };

    handleManualOrderClick = () => {
        this.props.dispatchCloseColorantPackagesConfirmOrderStockModalAction();
        this.props.dispatchOpenManualOrderStockModalAction();
    };

    handleSubmit = () => {
        this.props.dispatchAddColorantPackagesOrdersAction(this.props.cart.colorantPackages);
    };

    getTableHeader = () => {
        return modelHelper.buildTableRow([
            modelHelper.buildTableCell(<Translate value="general.colorant" />),
            modelHelper.buildTableCell(<Translate value="general.amount" />)
        ]);
    };

    getTableColumns = () => {
        return [modelHelper.buildTableColumn("col-10"), modelHelper.buildTableColumn("col-2 text-center")];
    };

    getTableRows = () => {
        return this.props.cart.colorantPackages.map((colorantPackage) => {
            return modelHelper.buildTableRow(
                [
                    modelHelper.buildTableCell(
                        <span>
                            {colorantPackage.colorant}{" "}
                            <span className="color-light-blue font-0_75em">({colorantPackage.database})</span>
                        </span>
                    ),
                    modelHelper.buildTableCell(colorantPackage.value)
                ],
                "",
                colorantPackage.key
            );
        });
    };

    getColorantPackagesToOrder = () => {
        return (
            <Table
                variant={TABLE_VARIANT_SECONDARY}
                tableHeader={this.getTableHeader()}
                tableRows={this.getTableRows()}
                tableColumns={this.getTableColumns()}
            />
        );
    };

    getHeader = () => {
        return modelHelper.buildModalSection(translate("stock.orderSummary"));
    };

    getContent = () => {
        return modelHelper.buildModalSection(this.getColorantPackagesToOrder());
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button label={<Translate value="stock.manualOrder" />} onClick={this.handleManualOrderClick} />
                <Button
                    label={<Translate value="sendOrderModal.sendOrder" />}
                    disabled={true}
                    onClick={this.handleSubmit}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={this.getHeader()}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    minWidth: "40%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        cart: store.stock.cart,
        colorantPackages: store.stock.colorantPackages
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseColorantPackagesConfirmOrderStockModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.COLORANT_PACKAGES_CONFIRM_ORDER_STOCK_MODAL));
        },
        dispatchAddColorantPackagesOrdersAction: (colorantPackages) => {
            dispatch(stockActions.addColorantPackagesOrders(colorantPackages));
        },
        dispatchOpenManualOrderStockModalAction: () => {
            dispatch(navigationActions.openModal(0, componentTypes.MANUAL_ORDER_STOCK_MODAL));
        }
    };
};

export default ColorantPackagesConfirmOrderStockModal = connect(
    mapStoreToProps,
    mapDispatchToProps
)(ColorantPackagesConfirmOrderStockModal);
